/** Created by zhanlihong on 2019/1/24 **/
let success = false; //声明一个全局变量用来判断是否登录
let userId = '';
let userName = '';
let isBindRole = false; //是否绑定角色
let baseurl = 'http://event.wanmei.com/';


(function ($) {

  $.maskBodyEle = $('#bodyMask');
  $.urls = {
    init: baseurl + 'w2i/signlot19/init',   //初始化
    bindRloe: baseurl + 'w2i/signlot19/saveMsg',   //绑定或更改角色信息
    sign: baseurl + 'w2i/signlot19/sign',   //签到
    lottery: baseurl + 'w2i/signlot19/lottery',  //抽奖
    getLottery: baseurl + 'w2i/signlot19/getRollList',    //查看最新获奖信息
    myprize: baseurl + 'w2i/signlot19/getMyLotPrize',    //查看最新获奖信息
    getSignPrize: baseurl + 'w2i/signlot19/getSignPrize',    //领取签到奖励
  }

  $.today = '';


  $.myChanceCount = 0;  //剩余抽奖次数
  $.myPrize = [];
  $.signTimes = 0;
  $.signPrize = [];

  $.fn.subform = function () {  //提交绑定角色信息
    if ($(this).length == 0) {
      return false;
    }
    var $this = $(this);
    $("#bindRoleBtn").off("click").on("click", function () {

      if (!$('[name=truename]').val().trim()) {
        alert('请填写您的姓名');
        return;
      }
      if (!$('[name=phone]').val().trim()) {
        alert('请填写您的电话');
        return;
      }
      if (!$('[name=address]').val().trim()) {
        alert('请填写您的收获地址');
        return;
      }
      if (!/^\d{11}$/.test($('[name=phone]').val().trim())) {
        alert('请正确输入您的电话');
        $('[name=phone]').focus();
        return;
      }

      $.ajax({
        url: $.urls.bindRloe,
        dataType: "jsonp",
        data: $('#usertcForm').serialize(),

        success: function (rdata) {

          if (rdata.success) {

            alert(rdata.message);
            isBindRole = true;
            $("#serverPop").add($.maskBodyEle).fadeOut(400);
            getUserInfo();

          } else {
            //显示错误
            alert(rdata.message)

          }
        },
        error: function () {
          alert("网络错误，请稍后重试！")
        }
      });
      return false;
    });
  };


  $.fn.lucky = function (options) {
    if ($(this).length == 0) {
      return false;
    }
    var opts = $.extend({
      time: 600,//默认启动时间
      slownum: 5,//加速或者减速个数
      circle: 2,//默认移动几圈开始获取中奖没有
      endback: function () {
      }//结束后执行
    }, options);

    function turntable(t) {
      this.t = t;
      this.list = this.t.find("li");//列表
      this.len = this.list.length;//个数
      this.interval = "";//时间对象
      this.record = 0;//记录滚动次数，列表个数为准，不是圈
      this.time = opts.time;//默认启动时间
      this.luckyCode = "";//中奖码
      this.slowCode = "";//减速索引
      this.slownum = opts.slownum;//加速或者减速个数
      this.circle = opts.circle;//默认移动几圈开始获取中奖没有
      this.slowstatus = false;//是否是减速状态
      this.endback = opts.endback;//结束后执行
    };
    turntable.prototype = {
      init: function () {
        var _this = this;
        //转盘启动
        _this.rotating();

      },
      //转动切换列表状态
      changeStatus: function () {
        var _this = this;
        if (_this.t.find(".on").length == 0) {
          _this.list.eq(0).addClass("on");
        } else {
          var _index = _this.t.find(".on").index();
          _this.list.removeClass("on");
          _index = (_index + 1) >= _this.len ? 0 : _index + 1;
          _this.list.eq(_index).addClass("on");
        }
        return _this;
      },
      //转动开始
      begin: function () {
        var _this = this;
        _this.record = _this.record + 1;
        //5个后开始加速
        if (_this.record <= _this.slownum) {
          //逐步启动
          _this.time = _this.time - 100;
        } else {
          //判断不处于减速状态
          if (!_this.slowstatus) {
            //开始匀速运行
            _this.time = 100;
          }
        }
      },
      //移动中
      move: function () {
        var _this = this;
        //默认跑4圈开始搜索获奖码
        if (_this.record / _this.len < _this.circle) {
          return false;
        }

        //获取中奖码
        _this.luckyCode = +(_this.t.data("data-lucky"));
        //判断减速时开始索引
        _this.slowCode = _this.luckyCode - _this.slownum >= 0 ? _this.luckyCode - _this.slownum : _this.len + _this.luckyCode - _this.slownum;
        return true;

      },
      //旋转结束
      end: function () {
        var _this = this;
        //判断当前选中索引
        var _index = _this.t.find(".on").index();
        if (_index == _this.slowCode) {
          _this.slowstatus = true;
        }
        if (_this.slowstatus) {
          _this.time = _this.time + 100;
          //停止

          if (_this.luckyCode == _index) {
            _this.endback();
            _this.resetorg();
            return true;
          }

        }
        return false;
      },
      //重置被改变的默认参数
      resetorg: function () {
        var _this = this;
        _this.record = 0;//记录滚动次数，列表个数为准，不是圈
        this.time = opts.time;//默认启动时间
        _this.luckyCode = "";//中奖码
        _this.slowCode = "";//减速索引
        _this.slowstatus = false;//是否是减速状态
        //按钮状态重置
        _this.t.attr("data-status", "true");
      },
      //开始抽奖转盘
      rotating: function () {
        var _this = this;
        if (_this.t.attr("data-status") == "false") {
          return false;
        }
        ;
        _this.t.attr("data-status", "false");
        _this.changeStatus();

        function zhuan() {
          _this.interval = window.setTimeout(function () {
            //启动5个慢热后加速
            _this.begin();
            //移动过程
            _this.move();
            //状态切换
            _this.changeStatus();
            //判断是否获得中奖码
            if (!_this.move()) {
              zhuan();
              return false;
            }
            //判断是否停止
            if (_this.end()) {
              window.clearTimeout(_this.interval);
            } else {
              zhuan();
              return false;
            }

          }, _this.time);
        };
        zhuan();
        return _this;
      }
    };
    $(this).each(function () {
      var $this = $(this);
      var obj = new turntable($this);
      obj.init();
    });
  };
  $.fn.getluck = function (options) {
    if ($(this).length == 0) {
      return false;
    }
    var opts = $.extend({}, options);

    var $this = $(this);
    //抽奖
    $.ajax({
      url: $.urls.lottery,
      type: "GET",
      dataType: "jsonp",
      data: {},
      beforeSend: function () {
        // $.loadingShow();
      },
      complete: function () {
        // $.loadingHide();
      },
      success: function (data) {
        // console.log(data)
        //判断code
        if (data.success) {


          var i = data.status;

          //
          $this.data("data-lucky", i);
          $.myChanceCount--;
          //
          //转盘
          $this.lucky({
            endback: function () {
              $('#prizeName').text(data.message);
              $('.lottery-times').text($.myChanceCount)
              setTimeout(function () {

                if(data.status == 8){ //没有中奖
                  $('#mesTxt').text(data.message)
                  $('#winPop').add($.maskBodyEle).fadeIn()
                }else{
                  $('#prizeName').text(data.message)
                  $(".lottery-pop").add($.maskBodyEle).fadeIn();
                }


              }, 600)

            }
          });

        } else {
          alert(data.message);
        }

      },
      error: function () {
        alert("网络错误，请稍后重试！");
      }
    });
  };
  $.ajaxSetup({
    dataType: 'jsonp'
  })


})(jQuery)


$(function () {


  loginState(function () {
    initLoginAndLogout();

  });


  //初始化服务器列表
  $("#serverlist").serverlist({ //初始化服务器列表
    gamename: "w2i"
  });


  $('[close-pop]').on('click', function () {
    $(this).closest('.pop').add($.maskBodyEle).fadeOut()
  });


  $(".luckgo").on('click', function () {


    if (!success) {
      login();
      return;
    }
    console.log(isBindRole)
    if (!isBindRole) {
      bindRole();
      return;
    }

    if (!$.myChanceCount) {
      alert('抱歉，您的抽奖次数为0');
      return;
    }


    $(".luckbox").getluck();

    return false;

  })

  $('#myPrizeBtn').on('click', function () {  //查看我的奖品

    if (!success) {
      login();
      return;
    }

    if (!isBindRole) {
      bindRole();
      return;
    }

    $.ajax({
      url: $.urls.myprize,
      dataType: 'jsonp',
      success: function (data) {
        if(!data.length){
          alert('抱歉，您没有获奖记录');
          return;
        }
        console.table(data)
        let arr = data.map((v,i) => {
          let status = '';
          switch(v.status)
          {
            case 0:
              status = '等待发送';
              break;
            case 8:
              status = '发送成功';
              break;
            case 1:
              status = '发送成功';
              break;
            case 11:
              status = '等待发送';
              break;
            default:
              status = '发送失败'
          }
            return `<li><span class="w172">${v.prizename}</span><span class="w172">${v.status == 11 ? "" : v.serverName}</span><span class="w172">${v.status == 11 ? "" : v.roleName}</span><span class="w172">${status}</span><span class="w172">${v.createtime.slice(5,-3)}</span></li>`
        });

        $('#myPrizeList').html(arr.join(''));
        $('.prizelog-pop').add($.maskBodyEle).fadeIn();
      }
    })


  })


  //获取最新中奖信息
  $.ajax({
    url: $.urls.getLottery,
    dataType: 'jsonp',
    success: function (data) {

        if(!data.length) return;
        var arr = [];

        data.forEach(function (v, i) {
          arr[arr.length] = '<li><span class="name">' + v.roleName + '</span>获得：<span class="txt">' + v.prizename + '</span></li>'
        })
        $('#winList ul').html(arr.join(''));

        if ($('#winList').find("li").length > 12) {
          $('#winList').marquee({
            direction: 'up'
          });
        }


    }
  })



  $('#calendar').on('click','.today',function () {  //提交今日签到
    var $this = $(this);
    if (!success) {
      login();
      return;
    }

    if (!isBindRole) {
      bindRole();
      return;
    }
    $.ajax({
      url: $.urls.sign,
      success: function (data) {
        if(data.success){
          $this.removeClass('today').addClass('sign');
          $('#mesTxt').text(`签到成功，获得1次抽奖机会，您已累计签到${$.signTimes + 1}天`)
          $('#winPop').add($.maskBodyEle).fadeIn()
          getUserInfo();

        }else{
          alert(data.message)
        }
      }
    })
  })

  $('#signPrize').on('click','a',function () {
    var $this = $(this);
    if(this.classList.contains('dis') || this.classList.contains('down')){
      return;
    }
    $.ajax({
      url:$.urls.getSignPrize,
      data:{
        pid : $this.attr('pid')
      },
      success:function (data) {
        alert(data.message);
        if(data.success){
          $this.addClass('done').text('已领取')
        }

      }
    })
  })


})

function getUserInfo() {
  $.ajax({
    url: $.urls.init,
    success: function (data) {
      console.table(data)

      if (data.status === 1) {   //已登录未提交信息
        bindRole();
        // return;
      }
      if (data.status === 2 || data.status === 3) {
        isBindRole = true;
      }
      $.today = data.date;
      $.myChanceCount = data.leftTimes;
      $.signTimes = data.signTimes;

      $.signPrize = data.signPrize? data.signPrize.split(',') : []

      $('.money').text(data.consumeScore ? data.consumeScore : 0);
      $('.lottery-times').text($.myChanceCount);
      $(`[data-value=${$.today}]`).addClass('today').prevAll().addClass('no-sign');
      $('#signPrize').find('a').slice(0,Math.floor($.signTimes/5)).removeClass('dis').text('领取')
      if($.signPrize.length){
        $.signPrize.forEach(function (v,i) {
          $('#signPrize').find(`[pid=${v}]`).addClass('done').text('已领取');
        })
      }

      // $(`[data-value=2019-01-30]`).addClass('today').prevAll().addClass('no-sign');
      if(data.signDays && data.signDays.length){
        data.signDays.forEach((v,i) => {
          $(`[data-value=${v}]`).addClass('sign')
        })
      }

      if (data.status === 3) {  //今日已签到
        $(`[data-value=${$.today}]`).addClass('sign').removeClass('today')
      }
    }

  })
}

function bindRole() {    //显示绑定弹窗
  $("#serverPop,#bodyMask").fadeIn(400);
  $("#usertcForm").subform();

}


function loginOut() {
  var qurl = window.location.href;
  $(".logout").attr('href', 'https://passport.wanmei.com/sso/logout?serviceurl=' + qurl);
}

//登录JS
function login() {
  var loginUrl = 'http://passport.wanmei.com/sso/login?service=ssowanmei&continue=logintoiframe&isiframe=1&location=' + toHex(location.href);
  var layer = $('#loginLayer');
  if (layer.size() == 0) {
    layer = $('<div id="loginLayer"></div>');
    layer.css({
      'width': '624px',
      'height': '310px',
      'position': 'fixed',
      'left': '50%',
      'top': '50%',
      'margin-left': '-312px',
      'margin-top': '-155px',
      'border-top': '3px solid #dc4949',
      'background': '#fff',
      'padding-top': '50px',
      'z-index': 11111
    });
    var closeBtn = $('<a onclick="closeLogin()"></a>')
    closeBtn.css({
      'position': 'absolute',
      'right': '14px',
      'top': '14px',
      'width': '20px',
      'height': '20px',
      'cursor': 'pointer',
      'background': 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKAgMAAADwXCcuAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEUAAAB6cHAAAAC7N4c0AAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAiSURBVAjXY3BgEABCBwYWRgYGRhYGBoYACAaxQWIgOaAaACdCAfWeiITAAAAAAElFTkSuQmCC) 50% 50% no-repeat'
    });
    layer.append(closeBtn);
    layer.append('<iframe scrolling="no" allowtransparency="yes" src="' + loginUrl + '" frameborder="0" width="624" height="310"></iframe>');
    $('body').append(layer);
  }
  $('.prompt_bg').show();
  layer.show();
}

function closeLogin() {
  $('.prompt_bg').hide();
  $('#loginLayer').hide();
}

function toHex(str) {
  var dest = "";
  for (var i = 0; i < str.length; i++) {
    dest += str.charCodeAt(i).toString(16);
  }
  return dest;
}

function loginState(fn) {
  $.ajax({
    url: "https://passport.wanmei.com/sso/loginstatus",
    type: "POST",
    dataType: "jsonp",
    jsonp: "jsonpCallback",
    success: function (data) {
      if (data.code == 0) {
        success = true;
        userId = data.data.id;
        userName = data.data.username;
        getUserInfo();
      }
      if (fn) {
        fn()
      }
    }
  });
}

//判断一个字符串为空
function isCorrectVal(value) {
  if (value === null || value === undefined || value.trim().length === 0) {
    return false;
  }
  return true;
}

function initLoginAndLogout() {

  if (userName == '') {
    $('.loginBf').css({'display': 'block'})
    $('#loginBtn').on('click', function () {
      login()
    })
  } else {
    $('.loginBf').hide();

    $('.logout').click(function () {
      loginOut();
    });
    $('.loginafter').show();
    $('.loginafter .user_msg').html(userName);
  }
}



